module.exports = __webpack_public_path__ + "2251a3823683f3729a355cd548cbfa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat-learnmore-hero.png
// module id = 2712
// module chunks = 0 1